module.exports = __webpack_public_path__ + "img/close-button.60f8b75a.svg";